import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetProductSaleReportApi } from "./Report.action";
import { Link } from "react-router-dom";
import { CalendarIcon, DownloadIcon, ChevronRightIcon } from "../../../components/Icons";
import { getUserRes } from "../../AddUser/user.actions";
import _ from "lodash";
import Swal from "sweetalert";
import moment from "moment";
import SinglePageDashboard from "../../../drawer/SinglePageDashbord";
import GlobalFormCard from "../../../components/GlobalFormCard";
import DateField from "../../../components/DateField";
import "./Report.css";
import SelectorField from "../../../components/SelectorField";


const ProductSaleReport = (props) => {
    const [startDate, setStartDate] = useState(moment().startOf('month').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [bookerId, setBookerId] = useState("");
    const isDisabled = _.isEmpty(startDate) || _.isEmpty(endDate) || props.isFetchingProductReport || props.isFetchingUser;;

    const handleDangerVisible = () => {
        Swal({
            title: "Error",
            text: "Something went wrong!",
            icon: "error",
            button: "Ok",
        });
    };

    const GenratePDF = () => {
        props.GetProductSaleReportApi({
            startDate: startDate,
            endDate: endDate,
            ...(bookerId && { bookerId })
        },
            handleDangerVisible,
        );
    };

    const handleChangeBooker = (selectedOption) => {
        if (!selectedOption) {
            setBookerId("");
            return;
        }
        setBookerId(selectedOption.value);
    };
    const filterdUserList = _.isEmpty(props.userList) ? [] : props.userList.filter((e) => e.role === "booker");
    const BookerList = _.isEmpty(filterdUserList) ? [] : filterdUserList.map((x) => {
        let data = { value: x._id, label: x.userName };
        return data;
    });

    useEffect(() => {
        props.getUserRes();
    }, []);

    return (
        <>
            <SinglePageDashboard header="Product Sale Report" />

            <div className="page-container">
                <div className="breadcrumb">
                    <Link to="/home" className="breadcrumb-link">Home</Link>
                    <ChevronRightIcon />
                    <Link to="/report" className="breadcrumb-link">Reports</Link>
                    <ChevronRightIcon />
                    <span className="breadcrumb-current">Product Sale Report</span>
                </div>

                <div className="page-header">
                    <h1 className="page-title">Product Sale Report</h1>
                </div>

                <GlobalFormCard
                    title="Select Date"
                    subtitle="Report will be generated for this date"
                    icon={<CalendarIcon />}
                    maxWidth="900px"
                >
                    <DateField
                        label='Start Date'
                        value={startDate}
                        onChange={setStartDate}
                    />
                    <DateField
                        label='End Date'
                        value={endDate}
                        onChange={setEndDate}
                    />

                    <SelectorField
                        options={BookerList}
                        value={bookerId}
                        onChange={handleChangeBooker}
                        isDisabled={false}
                        isLoading={props.isFetchingUser}
                        label="Select Booker"
                    />

                    <div className="divider" />

                    <button
                        onClick={GenratePDF}
                        disabled={isDisabled}
                        className={`generate-btn ${isDisabled ? "disabled" : ""}`}
                    >
                        {props.isFetchingProductReport ? (
                            <>
                                <span className="spinner" />
                                Generating…
                            </>
                        ) : (
                            <>
                                <DownloadIcon />
                                Generate Report
                            </>
                        )}
                    </button>

                    <p className="footer-text">
                        Report will be downloaded as a PDF file
                    </p>

                </GlobalFormCard>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    GetProductSaleReportApi: (payload, handleDangerVisible) => dispatch(GetProductSaleReportApi(payload, handleDangerVisible)),
    getUserRes: () => dispatch(getUserRes()),
});

const mapStateToProps = (state) => ({
    isFetchingProductReport: state.ReportReducer.isFetchingProductReport,
    productSaleReportData: state.ReportReducer.productSaleReportData,
    isFetchingUser: state.UserReducer.isFetchingUser,
    userList: state.UserReducer.userList,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductSaleReport);